import React from 'react';
import PropTypes from 'prop-types';

import PageWrap from '@marvelapp/marvel-ui/page-wrap';
import Spacing from '@marvelapp/marvel-ui/spacing';
import Paragraph from '@marvelapp/marvel-ui/paragraph';
import Heading from '@marvelapp/marvel-ui/heading';

export default function CopyBlock({ title, children }) {
  return (
    <Spacing size="m" position="topBottom" type="margin">
      <Spacing size="xs" position="topBottom" type="padding">
        <PageWrap size="s">
          {title && (
            <Spacing size="l" position="topBottom" type="margin">
              <Heading tag="h2" weight="semibold" size="xxl">
                {title}
              </Heading>
            </Spacing>
          )}
          <Paragraph tag="p" size="xl">
            {children}
          </Paragraph>
        </PageWrap>
      </Spacing>
    </Spacing>
  );
}

CopyBlock.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node,
};



// WEBPACK FOOTER //
// ./src/components/modules/ContentBlocks/Copy/index.js